class NewsletterWrapper extends HTMLElement {
  constructor() {
    super();
    const _email = this.querySelector("#email_newsletter");
    const _email_input_wrapper = this.querySelector(
      "#email_newsletter-input-wrapper"
    );
    const _email_success = this.querySelector("#email_newsletter-success");
    const _email_error = this.querySelector("#email_newsletter-error");
    this.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault();
      this.subscribeCustomer(
        _email.value,
        _email_input_wrapper,
        _email_success,
        _email_error
      );
    });
  }

  async subscribeCustomer(
    _e,
    _email_input_wrapper,
    _email_success,
    _email_error
  ) {
    try {
      const url =
        "https://a.klaviyo.com/client/subscriptions/?company_id=Hau3wY";

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2024-02-15",
          "content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: `${_e.trim()}`,
                  },
                },
              },
            },
            relationships: { list: { data: { type: "list", id: "JMRcgh" } } },
          },
        }),
      };

      const request = await fetch(url, options);
      if (request.status === 202 || request.status === 200) {
        _email_success.classList.remove("hidden");
        _email_input_wrapper.classList.add("hidden");
        return request;
      } else {
        _email_error.classList.remove("hidden");
        _email_input_wrapper.classList.add("hidden");
      }
    } catch (err) {
      console.error(
        "uh oh! There was an error subscribing the customer: ",
        err
      );
    }
  }
}

customElements.define("newsletter-wrapper", NewsletterWrapper);
